/* @jsx jsx */
import { useEffect } from 'react';
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import VisuallyHidden from '@atlaskit/visually-hidden';
import messages from './messages';
import { buttonContainerStyles, getContainerStyles, textStyles, iconColor, getIconStyles, getTextContainerStyles } from './styles';
import { FloatingContainer } from '../../components/FloatingContainer/FloatingContainer';
import { scrollMarginStyles } from '../../components/FloatingContainer/styles';
import Button from '@atlaskit/button/standard-button';
import { useContainerBreakpoints } from '../../hooks/use-container-breakpoints';
import { AI_MODAL_SCREEN_CLASS } from '../../../utils/constants';
import { buttonAutoFocusRingFix } from '../../styles/focus';
export const DiscardScreen = ({
  onCancel,
  onDiscard,
  text
}) => {
  const {
    formatMessage
  } = useIntl();
  const {
    ref,
    breakpoint
  } = useContainerBreakpoints();

  // Scroll the discard screen into view if it's not fully visible
  useEffect(() => {
    if (ref.current) {
      ref.current.scrollIntoView({
        block: 'nearest'
      });
    }
  }, [ref]);
  return jsx(FloatingContainer, {
    ref: ref,
    "data-testid": "discard-screen"
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: `discard-screen ${AI_MODAL_SCREEN_CLASS}`,
    css: [getContainerStyles(breakpoint), scrollMarginStyles],
    paddingAdjustments: {
      top: 1,
      bottom: 1
    }
  }, jsx(VisuallyHidden, null, formatMessage(messages.warningIconLabel)), jsx("div", {
    css: getTextContainerStyles(breakpoint)
  }, jsx("span", {
    css: getIconStyles(breakpoint)
  }, jsx(WarningIcon, {
    label: formatMessage(messages.warningIconLabel),
    primaryColor: iconColor
  })), jsx("p", {
    css: textStyles
  }, text)), jsx("div", {
    css: buttonContainerStyles
  }, jsx(Button, {
    testId: "cancel-button",
    spacing: "compact",
    onClick: onCancel,
    type: "button",
    appearance: "subtle"
  }, formatMessage(messages.cancelLabel)), jsx(Button, {
    autoFocus: true,
    css: buttonAutoFocusRingFix,
    testId: "discard-button",
    spacing: "compact",
    onClick: onDiscard,
    type: "button",
    appearance: "warning"
  }, formatMessage(messages.discardLabel))));
};